import anime from 'animejs';
import Scene from '../classes/scene';
import SceneManager from '../classes/scene-manager';
import { ScrollDirection } from '../classes/scroll-manager';
import { getEl, getEls } from '../helpers';
import AnimationDebugger from '../components/animation-debugger';

export default class ContinuousDiscovery extends Scene {

	sectionSelector = '#continuous-discovery';

	constructor(manager: SceneManager, targetContainer: string) {
		super(manager, targetContainer);

        this.addAnimation({
           loop: true,
           targets: getEl('.cd-marquee'),
           translateX: ['0%', '-100%'],
           easing: "linear",
           duration: 30000,
        });

        this.manager.app.scroller.addVisibilityTrigger(
            this.elContainer,
            (dir) => {
                this.onEnteredView(dir);
            },
            1
        );

		//Uncomment this to attach an animation debugger.
		//const animDebug = new AnimationDebugger(this.mediaTimeline, getEl('#intro-sequence'));

	}

}
